// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import {
  MobileListItem,
  MobileListWrapper,
} from '../../utils/Styles/MobileListItem';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const PartiesMobileList = ({ content, getPartyDate, onClick }) => {
  return (
    <MobileListWrapper>
      {content // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        .map(party => (
          <MobileListItem
            key={party.partyId}
            onClick={e => onClick(e, `/party/${party.partyId}`)}
          >
            <div>
              <h5 className='title'>{party.partyName}</h5>
              <div className='item'>{party.partyDescription}</div>
            </div>
            <div>
              <div className='bold-item'>{getPartyDate(party)}</div>
              <div className='label-item'>
                {party.partyLocation
                  ? party.partyLocation.address
                  : 'Location Unknown'}
              </div>
            </div>
          </MobileListItem>
        ))}
    </MobileListWrapper>
  );
};

export default PartiesMobileList;
